"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPillHeader = void 0;
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var FilterPill_1 = require("../../react/components/FilterPill");
var useFilterPillHeaderStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    filterPillWrapper: {
        paddingBottom: "2px",
    },
    resetFilterLink: {
        color: theme.colors.primary,
        fontSize: "14px",
        fontWeight: 500,
        paddingInlineStart: theme.spacing.base,
        "&:hover": {
            cursor: "pointer",
        },
        display: "inline-block",
        lineHeight: "32px",
    },
}); });
var FilterPillHeader = function (_a) {
    var emitTrackingEvent = _a.emitTrackingEvent, isMobile = _a.isMobile, onClearFiltersClicked = _a.onClearFiltersClicked, pills = _a.pills, translate = _a.translate;
    var classes = useFilterPillHeaderStyles();
    var styleOverride = isMobile ? { paddingLeft: "5px", paddingRight: "5px" } : {};
    return (react_1.default.createElement("div", { className: classes.filterPillWrapper, style: styleOverride },
        pills.map(function (pill, index) {
            return (react_1.default.createElement(FilterPill_1.FilterPill, { emitTrackingEvent: emitTrackingEvent, key: pill.label + index, onFilterClose: pill.onFilterClose, label: pill.label, translate: translate }));
        }),
        !isMobile && pills.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classes.resetFilterLink, "data-ta-locator": "FilterPillHeader-clearFilters", onClick: onClearFiltersClicked }, translate("search.filters.clear_filters")))) : null));
};
exports.FilterPillHeader = FilterPillHeader;
exports.FilterPillHeader.displayName = "FilterPillHeader";
//# sourceMappingURL=FilterPillHeader.js.map